// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main[data-v-390ce4b9]{position:relative}.red-dot[data-v-390ce4b9]{position:absolute;top:8px;right:8px;width:8px;height:8px;background:red;border-radius:9999px}", ""]);
// Exports
module.exports = exports;
